export default {_name:'box.text',module:'Card/Form',view:'Element/Box/Inline',options:{xs:12}}